"use client";

import { ContactForm } from "@/app/shared/common/ContactForm";
import { Box, Typography } from "@mui/material";

export function ContactPage() {
  return (
    <Box
      sx={{
        backgroundColor: "grey.100",
        flex: 'stretch'
      }}
    >
      <Box
        sx={(theme) => ({
          padding: 4,
          display: "flex",
          flexDirection: "column",
          gap: 4,
          maxWidth: "1200px",
          margin: "0 auto",
          background: "white",
          [theme.breakpoints.down("sm")]: {
            gap: 2,
          },
        })}
      >
        <Typography variant="h4" component="h1" align="center">
          Contact Us
        </Typography>
        <ContactForm />
      </Box>
    </Box>
  );
}
